export default __webpack_public_path__ + "static/media/JerseyLight.b88ca90c.svg";